import React from "react";

import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";

import {Collections, Parts, Elements} from "components";
import API from "@beardeddevops/react.api";

import {Alert, Button} from "reactstrap";
import Tooltip from "@material-ui/core/Tooltip";
import TransactionObject from "components/TransactionObject";
import UniversalModalOverride from "components/UniversalModalOverride";
import WarningAlert from "../Elements/DispositionPendingWarningAlert";


/**
 *  @property {Transactions_Collections_Object|Transactions_Collections_Is} state
 *  @property {object} model
 *  @property {Transactions_Collections_Properties} model.properties
 *  @property {Transactions_Collections_Is} model.is
 *  @property {Transactions_Collections_Has} model.has
 */
class DispositionBoundBookObject extends TransactionObject {
	constructor(props) {
		super(props, Types.Transactions_Collections._name);
		this.read = 'GET_DISPOSITION';
		this.update = typeof props.id !== 'undefined' && props.id ? 'POST_DISPOSITION' : 'PUT_DISPOSITION';

		this.state.disposed_to = true;

		this.afterEventSave = this.setNewObject('event');
		this.afterCustomerSave = this.setNewObject('customer');
		this.afterExportSave = this.setNewObject('exporter');
		this.state.product_types = [];

	}


	componentDidMount() {
		super.componentDidMount();
		if(this.props.transaction_entries) {
			let transaction_entriess = [];
			for (let entry of this.props.transaction_entries) {
				transaction_entriess.push({
					pawn_redemption: false,
					pawn_redemption_error: "",
					product: entry.pkey,
					product_binary_id: entry.binary_id,
					products: entry
				});
			}
			this.setState({transaction_entriess});
		}

		if(this.props.order_id) {
			this.setState({foreign_order_id: this.props.order_id});
		}

	}


	/**
	 * @param prevProps
	 * @param {Transactions_Collections_Object} prevState
	 * @param snapshot
	 */
	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		// noinspection JSValidateTypes
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;

		if (typeof this.props.updateName === 'function') {
			this.props.updateName(object.transaction || (this.state.binary_id + '-' + this.state.pkey));
		}

		//If Pkey has always been blank || this isn't the initial load so pkey is the same
		if (prevState.pkey === object.pkey || prevState.binary_id === object.binary_id) {
			//TODO: Set Export Crap


			//If "Customer" select was updated, update corresponding Customer Information
			if (object.customers && object.customer !== prevState.customer) {
				this.setState({
					'customer_name_first': object.customer ? object.customers.name_first : '',
					'customer_name_middle': object.customer ? object.customers.name_middle : '',
					'customer_name_last': object.customer ? object.customers.name_last : '',
					'customer_name_suffix': object.customer ? object.customers.name_suffix : '',
					'customer_street_1': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_1 : '',
					'customer_street_2': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].street_2 : '',
					'customer_city': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].city : '',
					'customer_county': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].county : '',
					'customer_state': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].state : '',
					'customer_zip': object.customer && object.customers.customer_addressess.length > 0 ? object.customers.customer_addressess[0].zip : '',
					'customer_name_company': object.customer ? object.customers.name_company : ''
				});
			}
		}
	}



	// noinspection JSUnusedGlobalSymbols
	/**
	 * @param {Transactions_Collections_Object} data
	 */
	loadSelfAfter(data) {
		if (data.customer != null) {
			this.setState({'disposed_to': 'customer'});
		} else if (data.exporter != null) {
			this.setState({'disposed_to': 'exporter'});
		}
	};


	async handleSubmit(event, suppressToast = false) {
		this.state.products = this.state.transaction_entriess.map(entry => entry.products.binary_id + '-' + entry.products.pkey);
		await super.handleSubmit(event, suppressToast);
	};


	//Note: Doesn't need a form() function. Only ever used in a modal
	render() {
		/** @type {Transactions_Collections_Properties} properties */
		let properties = this.model.properties;
		/** @type {Transactions_Collections_Object} object */
		let object = this.state;
		let {loading} = this.state;
		return (
			<div>
				<Alert color={'warning'} >
					<p style={{fontSize: '18px', marginBottom: '0px'}}>
						<span ><strong>{"A Gunsmith or Quick Disposition is used for dispositions that do not require automated NICS background checks through FFL Boss"}</strong></span>
					</p>
				</Alert>
				<fieldset>
					<div className={"row"}>

						{/*#region Col 1*/}
						<div className={"col-md"}>

							{/*#region Details Section*/}
							<h4 className="section-title">Details</h4>
							<Parts.SelectLocation
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								locations={this.props.locations}
								states={this.props.states}
								filter={this.filterLocationOptions}
							/>

							<div className={"form-group"}>
								<div className={"row"}>
									<div className="col-sm">
										<span className="input-label">Disposed To</span>
									</div>
									<div className="col-sm text-right">

										<div className="form-group">
											<Framework.Elements.ButtonSwitch
												property={properties.disposed_to}
												value={object.disposed_to}
												error={object.disposed_to_error}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={'Customer'}
												labelFalse={'Exporter'}
											/>
										</div>
									</div>
								</div>

							</div>


							{this.state.disposed_to === true &&
								<Parts.TransactionCustomer
									locations={this.props.locations}
									states={this.props.states}
									object={object}
									properties={properties}
									shouldLoad={this.state.loaded}
									history={this.props.history}
									onTextUpdate={this.handleTextFieldPropertyUpdate}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									afterCustomerSave={this.afterCustomerSave}
									disableFields={true}
								/>}


							{this.state.disposed_to === false &&
								<Parts.TransactionExport
									locations={this.props.locations}
									states={this.props.states}
									object={object}
									properties={properties}
									history={this.props.history}
									shouldLoad={this.state.loaded}
									onSelectUpdate={this.handleSelectPropertyUpdate}
									afterExportSave={this.afterExportSave}
								/>}


							<Parts.TransactionDetails
								history={this.props.history}
								locations={this.props.locations}
								states={this.props.states}
								object={object}
								properties={properties}
								shouldLoad={this.state.loaded}
								onTextUpdate={this.handleTextFieldPropertyUpdate}
								onSelectUpdate={this.handleSelectPropertyUpdate}
								afterEventSave={this.afterEventSave}
								isDisposition={true}
							/>
							{/*#endregion*/}
							{this.props.rootState.hasMichiganRIModule && <section id={"ri-060"}>
								<h4 className="section-title">Michigan RI-060 Information</h4>
								<div>
									<div className={"row"}>
										<div className="col-6">
											<Framework.Elements.TextField
												label={'Mcoles #'}
												property={properties.mcoles_number}
												value={object.mcoles_number}
												error={object.mcoles_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="col-6">
											<Framework.Elements.TextField
												label={'CPL #'}
												property={properties.cpl_number}
												value={object.cpl_number}
												error={object.cpl_number_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>

									</div>
								</div> </section>}
						</div>

						{/*#endregion*/}

						{/*#region Col 2*/}
						<div className={"col-md"}>
							{/*#region Items Section*/}
							<h4 className="section-title">
								Items
								<div className="pull-right">
									<Tooltip
										title="Products you have previously acquired and disposed / transferred can be found here."
										aria-label="Products you have previously acquired and disposed / transferred can be found here.">
										<Button data-id={'quick-dispo-products'} onClick={this.handleToggleModalLookup} size={"sm"}
										        color="primary">
											<i className={"fa fa-barcode"}/>
											<span className="hidden-xs">&nbsp;&nbsp;Items</span>
										</Button>
									</Tooltip>

									<UniversalModalOverride
										locations={this.props.locations}
										states={this.props.states}
										history={this.props.history}
										name={"In Stock Products"}
										object={Collections.ProductsExisting}
										toggle={this.state.modalLookup}
										reportClose={this.handleReportProductClose}
										afterSave={this.addProducts}
										size={"xl"}
										status={"GET_IN_STOCK"}
										objectProps={{scannedCode: this.props.scannedCode}}
									/>

								</div>
							</h4>

							{object.transaction_entriess && object.transaction_entriess.map((entry, i) =>
								<Elements.Item
									key={i}
									entry={entry}
									product={entry.products}
									onDelete={this.deleteProduct}
									onUpdate={this.updateProduct}
									openModal={this.handleToggleProductModel('productUpdate' + i)}
									reportClose={this.handleReportModalClose('productUpdate' + i)}
									modalUpdate={this.state['productUpdate' + i]}
									locations={this.props.locations}
									states={this.props.states}
									history={this.props.history}
								/>)} {/*#endregion*/}

								<p style={{textAlign: 'center', color: 'grey'}}><i>{object.transaction_entriess.length} Total Items</i></p>

							{/*#endregion*/}
						</div>
						{/*#endregion*/}

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}

}


export default Framework.Components.withRootState(DispositionBoundBookObject);
